var cov_1p2cwn934f = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/TimeScroll.tsx",
      hash = "54c625241133a5934007ae9b9f531ca85c2b1b57",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/TimeScroll.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 19
        },
        end: {
          line: 8,
          column: 21
        }
      },
      "1": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "2": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "3": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 16
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 50
        }
      },
      "5": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 60
        }
      },
      "6": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 52
        }
      },
      "7": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 26
        }
      },
      "8": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 26
        }
      },
      "9": {
        start: {
          line: 41,
          column: 25
        },
        end: {
          line: 41,
          column: 35
        }
      },
      "10": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 63
        }
      },
      "11": {
        start: {
          line: 46,
          column: 27
        },
        end: {
          line: 46,
          column: 37
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "13": {
        start: {
          line: 47,
          column: 23
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "14": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "15": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 31
        }
      },
      "16": {
        start: {
          line: 52,
          column: 20
        },
        end: {
          line: 52,
          column: 31
        }
      },
      "17": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "18": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 58
        }
      },
      "19": {
        start: {
          line: 54,
          column: 47
        },
        end: {
          line: 54,
          column: 58
        }
      },
      "20": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 112
        }
      },
      "21": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 80
        }
      },
      "22": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 21
        }
      },
      "23": {
        start: {
          line: 66,
          column: 22
        },
        end: {
          line: 66,
          column: 32
        }
      },
      "24": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 29
        }
      },
      "25": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 29
        }
      },
      "26": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 101
        }
      },
      "27": {
        start: {
          line: 68,
          column: 95
        },
        end: {
          line: 68,
          column: 101
        }
      },
      "28": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "29": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 72,
          column: 8
        }
      },
      "30": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 46
        }
      },
      "31": {
        start: {
          line: 71,
          column: 26
        },
        end: {
          line: 71,
          column: 46
        }
      },
      "32": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 32
        }
      },
      "33": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 62
        }
      },
      "34": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 30
        }
      },
      "35": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 62
        }
      },
      "36": {
        start: {
          line: 87,
          column: 18
        },
        end: {
          line: 87,
          column: 65
        }
      },
      "37": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 47
        }
      },
      "38": {
        start: {
          line: 92,
          column: 27
        },
        end: {
          line: 92,
          column: 37
        }
      },
      "39": {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 65
        }
      },
      "40": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 50
        }
      },
      "41": {
        start: {
          line: 94,
          column: 44
        },
        end: {
          line: 94,
          column: 50
        }
      },
      "42": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "43": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 39
        }
      },
      "44": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 12
        }
      },
      "45": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 62
        }
      },
      "46": {
        start: {
          line: 99,
          column: 36
        },
        end: {
          line: 99,
          column: 62
        }
      },
      "47": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 18
        }
      },
      "48": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 58
        }
      },
      "49": {
        start: {
          line: 119,
          column: 47
        },
        end: {
          line: 119,
          column: 58
        }
      },
      "50": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 74
        }
      },
      "51": {
        start: {
          line: 120,
          column: 63
        },
        end: {
          line: 120,
          column: 74
        }
      },
      "52": {
        start: {
          line: 122,
          column: 32
        },
        end: {
          line: 122,
          column: 35
        }
      },
      "53": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 125,
          column: 39
        }
      },
      "54": {
        start: {
          line: 123,
          column: 14
        },
        end: {
          line: 123,
          column: 38
        }
      },
      "55": {
        start: {
          line: 124,
          column: 9
        },
        end: {
          line: 125,
          column: 39
        }
      },
      "56": {
        start: {
          line: 124,
          column: 40
        },
        end: {
          line: 124,
          column: 51
        }
      },
      "57": {
        start: {
          line: 125,
          column: 9
        },
        end: {
          line: 125,
          column: 39
        }
      },
      "58": {
        start: {
          line: 125,
          column: 23
        },
        end: {
          line: 125,
          column: 39
        }
      },
      "59": {
        start: {
          line: 127,
          column: 25
        },
        end: {
          line: 139,
          column: 6
        }
      },
      "60": {
        start: {
          line: 141,
          column: 22
        },
        end: {
          line: 141,
          column: 84
        }
      },
      "61": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "62": {
        start: {
          line: 155,
          column: 22
        },
        end: {
          line: 155,
          column: 32
        }
      },
      "63": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "64": {
        start: {
          line: 164,
          column: 34
        },
        end: {
          line: 164,
          column: 52
        }
      },
      "65": {
        start: {
          line: 171,
          column: 0
        },
        end: {
          line: 173,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 38
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 22
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 32
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 36
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 15
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 22
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 45
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 77
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 51
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 34
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 61
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 65
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 70,
            column: 17
          },
          end: {
            line: 70,
            column: 18
          }
        },
        loc: {
          start: {
            line: 70,
            column: 23
          },
          end: {
            line: 72,
            column: 7
          }
        },
        line: 70
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 18
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 76
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 29
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 81
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 21
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 86
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 91
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 102,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        loc: {
          start: {
            line: 102,
            column: 26
          },
          end: {
            line: 152,
            column: 3
          }
        },
        line: 102
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 3
          }
        },
        loc: {
          start: {
            line: 154,
            column: 11
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 154
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 164,
            column: 29
          },
          end: {
            line: 164,
            column: 30
          }
        },
        loc: {
          start: {
            line: 164,
            column: 34
          },
          end: {
            line: 164,
            column: 52
          }
        },
        line: 164
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        }],
        line: 47
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 47,
            column: 13
          }
        }, {
          start: {
            line: 47,
            column: 17
          },
          end: {
            line: 47,
            column: 21
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 31
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 31
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 53
      },
      "4": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 23
          }
        }, {
          start: {
            line: 53,
            column: 28
          },
          end: {
            line: 53,
            column: 63
          }
        }, {
          start: {
            line: 53,
            column: 67
          },
          end: {
            line: 53,
            column: 86
          }
        }],
        line: 53
      },
      "5": {
        loc: {
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 58
          }
        }, {
          start: {
            line: 54,
            column: 6
          },
          end: {
            line: 54,
            column: 58
          }
        }],
        line: 54
      },
      "6": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 29
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 29
          }
        }],
        line: 67
      },
      "7": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 101
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 101
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 101
          }
        }],
        line: 68
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 43
          }
        }, {
          start: {
            line: 68,
            column: 47
          },
          end: {
            line: 68,
            column: 66
          }
        }, {
          start: {
            line: 68,
            column: 70
          },
          end: {
            line: 68,
            column: 93
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }],
        line: 69
      },
      "10": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 46
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 46
          }
        }],
        line: 71
      },
      "11": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 50
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 50
          }
        }],
        line: 94
      },
      "12": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }],
        line: 95
      },
      "13": {
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 95,
            column: 32
          }
        }, {
          start: {
            line: 95,
            column: 36
          },
          end: {
            line: 95,
            column: 44
          }
        }, {
          start: {
            line: 95,
            column: 48
          },
          end: {
            line: 95,
            column: 53
          }
        }, {
          start: {
            line: 95,
            column: 57
          },
          end: {
            line: 95,
            column: 83
          }
        }],
        line: 95
      },
      "14": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 62
          }
        }, {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 99,
            column: 62
          }
        }],
        line: 99
      },
      "15": {
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 105,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 105,
            column: 14
          },
          end: {
            line: 105,
            column: 32
          }
        }],
        line: 105
      },
      "16": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 58
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 58
          }
        }],
        line: 119
      },
      "17": {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 32
          }
        }, {
          start: {
            line: 119,
            column: 36
          },
          end: {
            line: 119,
            column: 45
          }
        }],
        line: 119
      },
      "18": {
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 74
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 74
          }
        }, {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 74
          }
        }],
        line: 120
      },
      "19": {
        loc: {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 13
          }
        }, {
          start: {
            line: 120,
            column: 17
          },
          end: {
            line: 120,
            column: 41
          }
        }, {
          start: {
            line: 120,
            column: 45
          },
          end: {
            line: 120,
            column: 61
          }
        }],
        line: 120
      },
      "20": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 39
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 39
          }
        }],
        line: 123
      },
      "21": {
        loc: {
          start: {
            line: 124,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        }, {
          start: {
            line: 124,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        }],
        line: 124
      },
      "22": {
        loc: {
          start: {
            line: 124,
            column: 13
          },
          end: {
            line: 124,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 13
          },
          end: {
            line: 124,
            column: 25
          }
        }, {
          start: {
            line: 124,
            column: 29
          },
          end: {
            line: 124,
            column: 38
          }
        }],
        line: 124
      },
      "23": {
        loc: {
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        }, {
          start: {
            line: 125,
            column: 9
          },
          end: {
            line: 125,
            column: 39
          }
        }],
        line: 125
      },
      "24": {
        loc: {
          start: {
            line: 141,
            column: 38
          },
          end: {
            line: 141,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 38
          },
          end: {
            line: 141,
            column: 49
          }
        }, {
          start: {
            line: 141,
            column: 53
          },
          end: {
            line: 141,
            column: 66
          }
        }, {
          start: {
            line: 141,
            column: 70
          },
          end: {
            line: 141,
            column: 83
          }
        }],
        line: 141
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/TimeScroll.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { range } from '../utils/numbers';
import { datepickerClass } from './styles';
import paramUtils from './paramUtils';
import { getLocale } from '../locale';
var lineHeight = (cov_1p2cwn934f.s[0]++, 30);
var grayStyle = (cov_1p2cwn934f.s[1]++, {
  1: {
    color: '#888'
  },
  2: {
    color: '#ccc'
  },
  3: {
    color: '#eee'
  }
});
var DefaultValue = (cov_1p2cwn934f.s[2]++, {
  total: 60
});

var TimeScroll =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TimeScroll, _PureComponent);

  var _super = _createSuper2(TimeScroll);

  function TimeScroll(props) {
    var _this;

    _classCallCheck(this, TimeScroll);

    cov_1p2cwn934f.f[0]++;
    cov_1p2cwn934f.s[3]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_1p2cwn934f.s[4]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1p2cwn934f.s[5]++;
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    cov_1p2cwn934f.s[6]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TimeScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1p2cwn934f.f[1]++;
      cov_1p2cwn934f.s[7]++;
      this.updateScrollTop();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_1p2cwn934f.f[2]++;
      cov_1p2cwn934f.s[8]++;
      this.updateScrollTop();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      cov_1p2cwn934f.f[3]++;

      var _ref = (cov_1p2cwn934f.s[9]++, this.props),
          timeZone = _ref.timeZone;

      cov_1p2cwn934f.s[10]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "getValue",
    value: function getValue(v) {
      cov_1p2cwn934f.f[4]++;

      var _ref2 = (cov_1p2cwn934f.s[11]++, this.props),
          step = _ref2.step,
          ampm = _ref2.ampm;

      cov_1p2cwn934f.s[12]++;

      if ((cov_1p2cwn934f.b[1][0]++, !step) || (cov_1p2cwn934f.b[1][1]++, ampm)) {
        cov_1p2cwn934f.b[0][0]++;
        cov_1p2cwn934f.s[13]++;
        return v;
      } else {
        cov_1p2cwn934f.b[0][1]++;
      }

      cov_1p2cwn934f.s[14]++;
      return Math.ceil(v / step);
    }
  }, {
    key: "getItemStyle",
    value: function getItemStyle(num, isDisabled) {
      cov_1p2cwn934f.f[5]++;
      cov_1p2cwn934f.s[15]++;

      if (isDisabled) {
        cov_1p2cwn934f.b[2][0]++;
        cov_1p2cwn934f.s[16]++;
        return null;
      } else {
        cov_1p2cwn934f.b[2][1]++;
      }

      cov_1p2cwn934f.s[17]++;

      if ((cov_1p2cwn934f.b[4][0]++, this.props.ampm) || (cov_1p2cwn934f.b[4][1]++, typeof this.props.step === 'number') && (cov_1p2cwn934f.b[4][2]++, this.props.step > 0)) {
        cov_1p2cwn934f.b[3][0]++;
        cov_1p2cwn934f.s[18]++;

        if (this.props.value % this.props.step) {
          cov_1p2cwn934f.b[5][0]++;
          cov_1p2cwn934f.s[19]++;
          return null;
        } else {
          cov_1p2cwn934f.b[5][1]++;
        }

        cov_1p2cwn934f.s[20]++;
        return grayStyle[Math.ceil(Math.abs(this.props.value - num) / this.props.step)];
      } else {
        cov_1p2cwn934f.b[3][1]++;
      }

      cov_1p2cwn934f.s[21]++;
      return grayStyle[Math.abs(this.props.value - num)];
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1p2cwn934f.f[6]++;
      cov_1p2cwn934f.s[22]++;
      this.element = el;
    }
  }, {
    key: "updateScrollTop",
    value: function updateScrollTop() {
      var _this2 = this;

      cov_1p2cwn934f.f[7]++;

      var _ref3 = (cov_1p2cwn934f.s[23]++, this.props),
          value = _ref3.value;

      cov_1p2cwn934f.s[24]++;

      if (!this.element) {
        cov_1p2cwn934f.b[6][0]++;
        cov_1p2cwn934f.s[25]++;
        return;
      } else {
        cov_1p2cwn934f.b[6][1]++;
      }

      cov_1p2cwn934f.s[26]++;

      if ((cov_1p2cwn934f.b[8][0]++, typeof this.props.step === 'number') && (cov_1p2cwn934f.b[8][1]++, this.props.step > 0) && (cov_1p2cwn934f.b[8][2]++, value % this.props.step)) {
        cov_1p2cwn934f.b[7][0]++;
        cov_1p2cwn934f.s[27]++;
        return;
      } else {
        cov_1p2cwn934f.b[7][1]++;
      }

      cov_1p2cwn934f.s[28]++;

      if (this.element.scrollTop !== lineHeight * value) {
        cov_1p2cwn934f.b[9][0]++;
        cov_1p2cwn934f.s[29]++;
        setTimeout(function () {
          cov_1p2cwn934f.f[8]++;
          cov_1p2cwn934f.s[30]++;

          if (_this2.element) {
            cov_1p2cwn934f.b[10][0]++;
            cov_1p2cwn934f.s[31]++;

            _this2.scrollToValue();
          } else {
            cov_1p2cwn934f.b[10][1]++;
          }
        });
      } else {
        cov_1p2cwn934f.b[9][1]++;
      }
    }
  }, {
    key: "scrollToValue",
    value: function scrollToValue() {
      cov_1p2cwn934f.f[9]++;

      var _ref4 = (cov_1p2cwn934f.s[32]++, this.props),
          value = _ref4.value;

      cov_1p2cwn934f.s[33]++;
      this.element.scrollTop = lineHeight * this.getValue(value);
    }
  }, {
    key: "handleClick",
    value: function handleClick(value) {
      cov_1p2cwn934f.f[10]++;
      cov_1p2cwn934f.s[34]++;
      this.props.onChange(value);
      cov_1p2cwn934f.s[35]++;
      this.element.scrollTop = lineHeight * this.getValue(value);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      cov_1p2cwn934f.f[11]++;
      var value = (cov_1p2cwn934f.s[36]++, Math.round(this.element.scrollTop / lineHeight));
      cov_1p2cwn934f.s[37]++;
      this.element.scrollTop = lineHeight * value;
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      cov_1p2cwn934f.f[12]++;

      var _ref5 = (cov_1p2cwn934f.s[38]++, this.props),
          step = _ref5.step,
          ampm = _ref5.ampm;

      var value = (cov_1p2cwn934f.s[39]++, Math.round(this.element.scrollTop / lineHeight));
      cov_1p2cwn934f.s[40]++;

      if (value * step === this.props.value) {
        cov_1p2cwn934f.b[11][0]++;
        cov_1p2cwn934f.s[41]++;
        return;
      } else {
        cov_1p2cwn934f.b[11][1]++;
      }

      cov_1p2cwn934f.s[42]++;

      if ((cov_1p2cwn934f.b[13][0]++, typeof step === 'number') && (cov_1p2cwn934f.b[13][1]++, step > 0) && (cov_1p2cwn934f.b[13][2]++, !ampm) && (cov_1p2cwn934f.b[13][3]++, value !== this.props.value)) {
        cov_1p2cwn934f.b[12][0]++;
        cov_1p2cwn934f.s[43]++;
        this.props.onChange(value * step);
        cov_1p2cwn934f.s[44]++;
        return;
      } else {
        cov_1p2cwn934f.b[12][1]++;
      }

      cov_1p2cwn934f.s[45]++;

      if (value !== this.props.value) {
        cov_1p2cwn934f.b[14][0]++;
        cov_1p2cwn934f.s[46]++;
        this.props.onChange(value);
      } else {
        cov_1p2cwn934f.b[14][1]++;
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(num) {
      cov_1p2cwn934f.f[13]++;

      var _ref6 = (cov_1p2cwn934f.s[47]++, this.props),
          ampm = _ref6.ampm,
          _ref6$total = _ref6.total,
          total = _ref6$total === void 0 ? (cov_1p2cwn934f.b[15][0]++, DefaultValue.total) : _ref6$total,
          value = _ref6.value,
          step = _ref6.step,
          mode = _ref6.mode,
          min = _ref6.min,
          max = _ref6.max,
          ra = _ref6.range,
          current = _ref6.current,
          disabled = _ref6.disabled,
          disabledTime = _ref6.disabledTime,
          index = _ref6.index,
          rangeDate = _ref6.rangeDate;

      cov_1p2cwn934f.s[48]++;

      if ((cov_1p2cwn934f.b[17][0]++, typeof step === 'number') && (cov_1p2cwn934f.b[17][1]++, step <= 0)) {
        cov_1p2cwn934f.b[16][0]++;
        cov_1p2cwn934f.s[49]++;
        return null;
      } else {
        cov_1p2cwn934f.b[16][1]++;
      }

      cov_1p2cwn934f.s[50]++;

      if ((cov_1p2cwn934f.b[19][0]++, !ampm) && (cov_1p2cwn934f.b[19][1]++, typeof step === 'number') && (cov_1p2cwn934f.b[19][2]++, num % step !== 0)) {
        cov_1p2cwn934f.b[18][0]++;
        cov_1p2cwn934f.s[51]++;
        return null;
      } else {
        cov_1p2cwn934f.b[18][1]++;
      }

      var text = (cov_1p2cwn934f.s[52]++, num);
      cov_1p2cwn934f.s[53]++;

      if (ampm) {
        cov_1p2cwn934f.b[20][0]++;
        cov_1p2cwn934f.s[54]++;
        text = ['am', 'pm'][num];
      } else {
        cov_1p2cwn934f.b[20][1]++;
        cov_1p2cwn934f.s[55]++;

        if ((cov_1p2cwn934f.b[22][0]++, total === 12) && (cov_1p2cwn934f.b[22][1]++, num === 0)) {
          cov_1p2cwn934f.b[21][0]++;
          cov_1p2cwn934f.s[56]++;
          text = '12';
        } else {
          cov_1p2cwn934f.b[21][1]++;
          cov_1p2cwn934f.s[57]++;

          if (num < 10) {
            cov_1p2cwn934f.b[23][0]++;
            cov_1p2cwn934f.s[58]++;
            text = "0".concat(num);
          } else {
            cov_1p2cwn934f.b[23][1]++;
          }
        }
      }

      var _ref7 = (cov_1p2cwn934f.s[59]++, paramUtils.judgeTimeByRange({
        target: num,
        value: current,
        mode: mode,
        min: min,
        max: max,
        range: ra,
        disabled: disabled,
        disabledTime: disabledTime,
        options: this.getOptions(),
        index: index,
        rangeDate: rangeDate
      })),
          _ref8 = _slicedToArray(_ref7, 1),
          isDisabled = _ref8[0];

      var className = (cov_1p2cwn934f.s[60]++, datepickerClass((cov_1p2cwn934f.b[24][0]++, !isDisabled) && (cov_1p2cwn934f.b[24][1]++, value === num) && (cov_1p2cwn934f.b[24][2]++, 'time-active')));
      cov_1p2cwn934f.s[61]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: num,
          className: className,
          style: this.getItemStyle(num, isDisabled),
          onClick: this.handleClick.bind(this, num),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 143,
            columnNumber: 7
          }
        }, text)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      cov_1p2cwn934f.f[14]++;

      var _ref9 = (cov_1p2cwn934f.s[62]++, this.props),
          total = _ref9.total;

      cov_1p2cwn934f.s[63]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          className: datepickerClass('time-list'),
          onMouseLeave: this.handleMouseLeave,
          onScroll: this.handleScroll,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 157,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('pad'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 163,
            columnNumber: 9
          }
        }), range(total, 0).map(function (v) {
          cov_1p2cwn934f.f[15]++;
          cov_1p2cwn934f.s[64]++;
          return _this3.renderItem(v);
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('pad'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 165,
            columnNumber: 9
          }
        }))
      );
    }
  }]);

  return TimeScroll;
}(PureComponent);

TimeScroll.defaultProps = DefaultValue;
cov_1p2cwn934f.s[65]++;
TimeScroll.defaultProps = {
  total: 60
};
export default TimeScroll;